import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
  surveys: { results: [] }
}

export const getters = {
  surveys: (state) => state.surveys
}

export const mutations = {
  CACHE_SURVEYS(state, data) {
    state.surveys = data
  }
}

export const actions = {
  fetchSurveys({ commit }, params) {
    return axios.get(`${serverUrl}/assessment/survey/`, { params }).then(res => {
      if (res.status !== 200) return
      commit('CACHE_SURVEYS', res.data)
      return res
    })
  },
}


